/**
 * An observation's sample is shown raw, exactly as Langfuse returns it, but a
 * mapping reads the scoring paths (see `domain/slots.py`): `input.*` and
 * `output.*` are the same, Langfuse's `metadata.*` is `meta.*`, and every other
 * raw field is `observation.*`. These translate between the two.
 */

const SAME = new Set(["input", "output"]);

/** A path picked in the raw view, as the mapping path that reads it. */
export function mappingPath(rawPath: string): string {
  const head = rawPath.split(/[.[]/, 1)[0]!;
  if (SAME.has(head)) return rawPath;
  if (head === "metadata") return `meta${rawPath.slice(head.length)}`;
  return `observation.${rawPath}`;
}

/** The raw observation laid out by mapping paths, so `valueAt(view, path)`
 *  shows what a mapping path reads. */
export function mappingView(raw: Record<string, unknown>): Record<string, unknown> {
  return { input: raw.input, output: raw.output, meta: raw.metadata, observation: raw };
}
